import React, { useMemo } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { FormField } from "./FormField";

/**
 * Select a purchase pending truck lab, optionally filtered by party.
 */
export function PurchasePendingSelect({
  purchases,
  partyId,
  value,
  onChange,
  requireParty,
  label = "Purchase",
  testId = "lab-purchase-select",
}) {
  const filtered = useMemo(() => {
    if (!partyId && requireParty) return [];
    if (!partyId) return purchases;
    return purchases.filter((p) => String(p.party_id) === String(partyId));
  }, [purchases, partyId, requireParty]);

  const placeholder = requireParty && !partyId
    ? "Select party first…"
    : filtered.length === 0
      ? "No purchases awaiting truck lab"
      : "Select purchase pending truck lab…";

  return (
    <FormField
      label={label}
      required
      hint={
        partyId
          ? `${filtered.length} purchase(s) for selected party`
          : requireParty
            ? "Choose party to narrow the list"
            : `${filtered.length} purchase(s) in queue`
      }
      className="md:col-span-2 lg:col-span-3"
    >
      <Select
        value={value || "_none"}
        onValueChange={(v) => onChange(v === "_none" ? "" : v)}
        disabled={requireParty && !partyId}
      >
        <SelectTrigger data-testid={testId}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="_none" disabled>
            {placeholder}
          </SelectItem>
          {filtered.map((p) => (
            <SelectItem key={p.id} value={String(p.id)}>
              {p.vehicle_number ? `${String(p.vehicle_number).toUpperCase()} · ` : ""}
              {p.code} — {p.party_name} · {p.variety} · {p.state}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FormField>
  );
}
